// extracted by mini-css-extract-plugin
export default {"tetris-wrapper":"Tetris_tetris-wrapper__j1DFU","tetris":"Tetris_tetris__xaTdL","aside-container":"Tetris_aside-container__eUnqv"};